export default "__VITE_ASSET__3famXyyH__"